export default () => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
    },
});
